import React from 'react';

import classNames from 'classnames';

import Dialog from '@material-ui/core/Dialog';
import { TransitionProps } from '@material-ui/core/transitions';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

type InputProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  title?: string;
  titleAction?: React.ReactNode;
  onClose?: (e?: any) => void;
  children: React.ReactNode;
  className?: string;
  fullScreen?: boolean;
  fullScreenAction?: React.ReactNode;
  transitionComponent?: React.ComponentType<
    TransitionProps & {
      children?: React.ReactElement<any, any> | undefined;
    }
  >;
  /**
   * Cypress selector for identifying buttons in end-to-end testing
   * sets the data-cy attribute on the button element
   * @see https://docs.cypress.io/guides/references/best-practices#Selecting-Elements
   */
  dataCy?: string;
};

export class UiDialog extends React.PureComponent<InputProps> {
  static Content = ({ children }: { children: React.ReactNode }) => (
    <div className="u-padding-lg">{children}</div>
  );

  static Actions = ({ children }: { children: React.ReactNode }) => {
    const childrenCount = React.Children.count(children);
    const style = classNames(
      'u-display-flex u-alignItems-center u-padding-lg',
      childrenCount > 1 ? 'u-justifyContent-spaceBetween' : 'u-justifyContent-flexEnd',
    );

    return (
      <div className="u-position-bottom-sticky u-background-white u-border-top">
        <div className={style}>{children}</div>
      </div>
    );
  };

  render() {
    const {
      size,
      title,
      titleAction,
      children,
      onClose,
      className,
      fullScreen,
      transitionComponent,
      fullScreenAction,
      dataCy,
    } = this.props;
    const fullWidth = Boolean(size);
    const centeringClass = onClose ? 'u-justifyContent-spaceBetween' : 'u-justifyContent-center';

    return (
      <Dialog
        fullScreen={fullScreen}
        fullWidth={fullWidth}
        open
        onClose={onClose}
        maxWidth={size}
        className={className}
        TransitionComponent={transitionComponent}
        // This property is important to stop MUI's dialog from stealing focus from other things, like ckeditor
        // https://github.com/mui/material-ui/issues/15694#issuecomment-514812038
        disableEnforceFocus
        data-cy={dataCy}
      >
        <div
          className={`u-display-flex u-alignItems-center u-background-primary typo-h6 u-color-white u-padding ${centeringClass}`}
        >
          {onClose && !titleAction && <div style={{ width: '24px' }} />}
          {titleAction}
          {title && <div>{title}</div>}
          <div className="u-display-flex u-alignItems-center ">
            {fullScreenAction}
            {onClose && (
              <MaterialDesignIcon
                iconName={ICON_NAMES.CLOSE}
                onClick={onClose}
                className="u-colorHover-white"
              />
            )}
          </div>
        </div>
        <div className="u-flexColumn u-overflow-auto" data-cy="dialog-content">
          {children}
        </div>
      </Dialog>
    );
  }
}
